<tt-page class="col-xs-12 col-md-4 sp-0">
    <tt-card>
        <tt-button-goto ttText="add_new_oeestateremark" ttGoto="oeestateremark" [ttGotoParms]="{ oeestate_keyno: oeeStateKeyno, oeestateremark_keyno: '0' }" ttIcon="far fa-plus"></tt-button-goto>
    </tt-card>

    <tt-list [ttData]="itemsListRemarks"></tt-list>
</tt-page>
